<template>
  <v-list v-if="anos.Ano">
    <v-subheader
      >Filtrar por
      <span class="font-weight-bold ml-1 primary--text">ANO</span></v-subheader
    >
    <v-list-item-group v-if="anos.Ano" v-model="selectedItem" color="primary">
      <v-list-item
        v-for="(item, i) in anos.Ano.buckets"
        :key="i"
        @click="buscar(item)"
      >
        <v-list-item-content>
          <v-list-item-title v-text="item.key"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <span class="font-weight-normal body-2">{{ item.doc_count }}</span>
        </v-list-item-action>
      </v-list-item>
    </v-list-item-group>
    <!-- <v-skeleton-loader v-else v-bind="attrs" type="article"></v-skeleton-loader> -->
  </v-list>
</template>
<script>
export default {
  props: { anos: { type: Object } },
  data() {
    return {
      selectedItem: false,
      attrs: {}
    };
  },
  methods: {
    buscar(item) {
      item.ano = item.key;
      this.$emit("filtrarAggregations", item);
    }
  }
};
</script>
